module.exports = __webpack_public_path__ + "media/images/avatar/development/parents/9-025227cd9547db7b059f9ae583cf846c.jpg";